import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useBuilderConfig, useBuilderMetadata, useField } from '../../context';
import { fieldBottomGapSx } from '../../helpers';

/**
 * Contact date type (annual campaigns): the date-typed merge fields from the
 * shared GET /templates result, keyed by field name and labelled by description.
 * Renders nothing until the metadata has loaded.
 */
export const ContactDateTypeField: React.FC = () => {
  const { value, onChange } = useField('metadataName');
  const config = useBuilderConfig();
  const metadata = useBuilderMetadata();

  if (!metadata) return null;

  const label = config?.contact_date_type?.label || 'Contact Date Type';
  const dateFields = metadata.filter(field => field.type === 'date');

  return (
    <FormControl sx={fieldBottomGapSx} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        MenuProps={{ disableScrollLock: true }}
        value={value || ''}
        onChange={(e: SelectChangeEvent) => onChange(e.target.value)}
        name="metadataName"
      >
        {dateFields.map(dateField => (
          <MenuItem value={dateField.name} key={dateField.name}>
            {dateField.description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
